/**
 * NavBarSubscriptionBlock.js — верхняя часть sidebar под логотипом.
 *
 * Показывает:
 * - статус подписки и дату paid_until
 * - кнопку «Управлять» → /billing
 * - кнопку «Админка» → /admin (см. adminAccess.js)
 */

import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { ButtonDefault } from "../controls/Button/ButtonDefault";
import Logo from "../Logo";
import LanguageSwitcher from "../../i18n/LanguageSwitcher";
import { useI18n } from "../../i18n/I18nProvider";
import {
  OnestBoldDefault,
  OnestNormalSmall,
} from "../styled/TextComponents";
import { isAdminUser } from "../../constants/adminAccess";

const NavBarSubscriptionBlock = ({ user, screenHeight }) => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const paidUntil = user.paid_until
    ? moment.utc(user.paid_until).tz(user.timezone || "Europe/Moscow")
    : null;

  const isSubscriptionActive = paidUntil?.isAfter(moment());

  return (
    <>
      <div style={{ marginTop: 20 }}>
        <Logo />
      </div>

      <div style={{ marginTop: 16 }}>
        <LanguageSwitcher compact ariaLabel={t("Язык интерфейса")} />
      </div>

      <div
        style={{
          marginTop: 16,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!user.paid_until ? (
          <OnestNormalSmall>{t("Подписка активна до:")}</OnestNormalSmall>
        ) : isSubscriptionActive ? (
          <OnestNormalSmall>{t("Подписка активна до:")}</OnestNormalSmall>
        ) : (
          <OnestNormalSmall>{t("Подписка приостановлена")}</OnestNormalSmall>
        )}

        <OnestBoldDefault>
          {paidUntil ? (
            paidUntil.format("DD.MM.YYYY")
          ) : (
            <OnestNormalSmall> </OnestNormalSmall>
          )}
        </OnestBoldDefault>
      </div>

      <div style={{ marginTop: 20 }} onClick={() => navigate("/billing")}>
        <ButtonDefault width={145} height={40} active={true}>
          {t("Управлять")}
        </ButtonDefault>
      </div>

      {isAdminUser(user.id) ? (
        <div
          style={{ marginTop: screenHeight < 660 ? 10 : 20 }}
          onClick={() => navigate("/admin")}
        >
          <ButtonDefault
            width={145}
            height={screenHeight < 660 ? 30 : 40}
            active={true}
          >
            {t("Админка")}
          </ButtonDefault>
        </div>
      ) : null}
    </>
  );
};

export default NavBarSubscriptionBlock;
